var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"contents"}},[(_vm.mode.isLg)?_vm._t("lg"):_vm._e(),_vm._v(" "),(_vm.mode.isLgMd)?_vm._t("lgmd"):_vm._e(),_vm._v(" "),(_vm.mode.isMd)?_vm._t("md"):_vm._e(),_vm._v(" "),(_vm.mode.isMdSm)?_vm._t("mdsm"):_vm._e(),_vm._v(" "),(_vm.mode.isSm)?_vm._t("sm"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }